import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TransferCustomerCateringUserContainersToStoreMutationVariables = Types.Exact<{
  user_uuids: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type TransferCustomerCateringUserContainersToStoreMutation = { __typename?: 'Mutation', transferCustomerCateringUserContainersToStore: boolean };


export const TransferCustomerCateringUserContainersToStoreDocument = gql`
    mutation TransferCustomerCateringUserContainersToStore($user_uuids: [ID!]!) {
  transferCustomerCateringUserContainersToStore(user_uuids: $user_uuids)
}
    `;
export type TransferCustomerCateringUserContainersToStoreMutationFn = Apollo.MutationFunction<TransferCustomerCateringUserContainersToStoreMutation, TransferCustomerCateringUserContainersToStoreMutationVariables>;

/**
 * __useTransferCustomerCateringUserContainersToStoreMutation__
 *
 * To run a mutation, you first call `useTransferCustomerCateringUserContainersToStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferCustomerCateringUserContainersToStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferCustomerCateringUserContainersToStoreMutation, { data, loading, error }] = useTransferCustomerCateringUserContainersToStoreMutation({
 *   variables: {
 *      user_uuids: // value for 'user_uuids'
 *   },
 * });
 */
export function useTransferCustomerCateringUserContainersToStoreMutation(baseOptions?: Apollo.MutationHookOptions<TransferCustomerCateringUserContainersToStoreMutation, TransferCustomerCateringUserContainersToStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferCustomerCateringUserContainersToStoreMutation, TransferCustomerCateringUserContainersToStoreMutationVariables>(TransferCustomerCateringUserContainersToStoreDocument, options);
      }
export type TransferCustomerCateringUserContainersToStoreMutationHookResult = ReturnType<typeof useTransferCustomerCateringUserContainersToStoreMutation>;
export type TransferCustomerCateringUserContainersToStoreMutationResult = Apollo.MutationResult<TransferCustomerCateringUserContainersToStoreMutation>;
export type TransferCustomerCateringUserContainersToStoreMutationOptions = Apollo.BaseMutationOptions<TransferCustomerCateringUserContainersToStoreMutation, TransferCustomerCateringUserContainersToStoreMutationVariables>;